import {
  DataProvider,
  GetListResult,
  GetManyParams,
  GetManyResult,
  GetOneParams,
  GetOneResult,
} from 'react-admin'
import { TICKET_IMPORT_UPDATES_URL } from '../api-urls'
import { get, getWithPagination } from '../common/fetch.utils'
import {
  filterParamsComposer,
  queryParamsComposer,
} from '../common/get-by-conditions.utils'
import { TicketAPIGetListParams } from '../common/ticket-api-get-list.params'
import filterMapper from './ticket-import-update-filter.mapper'
import { mapSortTicketImportUpdateParam } from './ticket-import-update-sort.mapper'
import { TicketImportUpdateDto } from '../dto/ticket-import-update.dto'

const provider = {
  getList: async (
    resource: string,
    { filter, sort, pagination }: TicketAPIGetListParams,
  ): Promise<GetListResult<TicketImportUpdateDto>> => {
    const filterParams = `u=>${filterParamsComposer('u', filter, filterMapper)}`
    const pathParams = queryParamsComposer(
      sort,
      pagination,
      mapSortTicketImportUpdateParam,
    )
    const path = `/${filterParams}${(pathParams && `?${pathParams}`) || ''}`

    const {
      data,
      range: { total },
    } = await getWithPagination<TicketImportUpdateDto[]>(
      `${TICKET_IMPORT_UPDATES_URL}/GetByConditions`,
      path,
    )

    return Promise.resolve({
      data,
      total,
    })
  },
  getOne: async (
    resource: string,
    { id }: GetOneParams,
  ): Promise<GetOneResult<TicketImportUpdateDto>> => {
    const data = await get<TicketImportUpdateDto>(
      TICKET_IMPORT_UPDATES_URL,
      `/${id}`,
    )
    return Promise.resolve({
      data,
    })
  },
  getMany: async (
    resource: string,
    { ids }: GetManyParams,
  ): Promise<GetManyResult<TicketImportUpdateDto>> => {
    const data = await get<TicketImportUpdateDto[]>(
      TICKET_IMPORT_UPDATES_URL,
      `/GetByConditions/o=>new int[] {${ids.toString()}}.Contains(o.Id)`,
    )
    return Promise.resolve({ data })
  },
} as DataProvider

export default provider
